/* eslint-disable import/prefer-default-export */
import * as RuleActions from '@src/redux/actions/rule.actions'
import * as FailedObjectActions from '@src/redux/actions/failed.object.actions'
import * as ComplianceActions from '@src/redux/actions/compliance.actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState, RuleState } from './default.state'

export type RulesActionType =
  | RuleActions.ActionTypes
  | FailedObjectActions.ActionTypes
  | ComplianceActions.ActionTypes

export function reducer(
  state = defaultState,
  action: RulesActionType
): RuleState {
  switch (action.type) {
    case ActionTypes.Rules.CHANGE_STATE:
    case ActionTypes.Compliance.CHANGE_STATE: {
      const { payload } = action
      return {
        ...state,
        ...payload
      }
    }
    case ActionTypes.Rules.GET_RULES:
    case ActionTypes.Compliance.GET_COMPLIANCE_RULES: {
      return {
        ...state,
        list: action.payload.rules,
        totalCount: action.payload.total,
        failedCount: action.payload.failing,
        passedCount: action.payload.passing,
        title: action.payload.title,
        pending: false
      }
    }
    case ActionTypes.Rules.GET_RULE_DETAILS: {
      return {
        ...state,
        ruleDetails: action.payload.rule,
        failedObjects: action.payload.failedObjects,
        pending: false
      }
    }
    case ActionTypes.Rules.GET_RULES_PENDING:
    case ActionTypes.Rules.GET_RULE_DETAILS_PENDING:
    case ActionTypes.Compliance.GET_COMPLIANCE_RULES_PENDING: {
      return { ...state, pending: action.payload.isPending }
    }
    case ActionTypes.FailedObject.DISMISS_PENDING:
    case ActionTypes.FailedObject.REMEDIATE_PENDING: {
      return {
        ...state,
        pending: action.payload.pending
      }
    }
    case ActionTypes.Rules.FAILED_COUNTS_RECORDS: {
      return { ...state, failedByRuleId: action.payload.failedByRuleId }
    }
    default: {
      return state
    }
  }
}
